
import SaleReconciliationDetailView from "../../components/SaleReconciliationDetailView";

SaleReconciliationDetailScreen.propTypes = {};

function SaleReconciliationDetailScreen(props) {

    return (
        <div>
            <SaleReconciliationDetailView primaryRole='SALE' />
        </div>
    );
}

export default SaleReconciliationDetailScreen;
